import { SearchParamType } from "@/types/SearchParamType";
import { createContext } from "react";
export var SearchFormContext = createContext({
    queryParamKey: SearchParamType.WHAT,
    queryValue: "",
    setQueryValue: function () { },
    locationParamKey: SearchParamType.WHERE,
    locationValue: "",
    setLocationValue: function () { },
    isRemoteOnlyParamKey: SearchParamType.IS_REMOTE_ONLY,
    isRemoteOnlyValue: false,
    setIsRemoteOnlyValue: function () { },
    countryParamKey: SearchParamType.COUNTRY,
    countryValue: "",
    setCountryValue: function () { },
    companyParamKey: SearchParamType.COMPANY,
    companyValue: "",
    setCompanyValue: function () { },
    occupationParamKey: SearchParamType.OCCUPATION,
    occupationValue: "",
    setOccupationValue: function () { },
    jobCategorySuidParamKey: SearchParamType.JOB_CATEGORY_SUID,
    jobCategorySuidValues: [],
    setJobCategorySuidValues: function () { },
});
